import { call, put, takeEvery } from "redux-saga/effects";
import { apiError, createUserSuccess } from "./actions"
import {verifyOTPNumberService, createUserService, getAccountInfo} from  '../../services/auth-service';

import { CREATE_USER, VERIFY_OTP_NUMBER, GET_ACCOUNT_INFO} from "./actionTypes";

function* createUserSaga({ payload: { user, history } }) {
  try {
    let data = {
        username: user.username,
        accountid: user.accountid
      }
    const response = yield call(createUserService, data)
    if(typeof response !== 'object'){
      let data = {
        isreadytobuy: false,
        isShowOtp: true,
        showModal: true
      }
      yield put(createUserSuccess(data))
    }else {
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('username');
          localStorage.setItem('access_token', response?.access_token);
          localStorage.setItem('refresh_token', response?.refresh_token);
          localStorage.setItem('username', response?.username);
          let data = {
            isreadytobuy: true,
            isShowOtp: false,
            showModal: false
          }
      yield put(createUserSuccess(data))
    }
  } catch (error) {
    yield put(apiError(error))
  }
}


function* sendOtpUpdateSaga({ payload: { user, history } }) {
    try {
      let data = {
          username: user.username,
          otpnumber: user.otpnumber
        }
      const response = yield call(verifyOTPNumberService, data)
      if(response !== null && response.statusCode !== 400){
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('username');
        localStorage.setItem('access_token', response?.access_token);
        localStorage.setItem('refresh_token', response?.refresh_token);
        localStorage.setItem('username', response?.username);
        let data = {
          isreadytobuy: true,
          isShowOtp: false,
          showModal: false
        }
        yield put(createUserSuccess(data))
      }else{
        yield put(apiError(response?.message))
      }
    } catch (error) {
      yield put(apiError(error))
    }
  }

  function* getAccountInfoSaga({ payload: { user, history } }) {
    try {
      let data = { accountid: user.accountid }
      const response = yield call(getAccountInfo, data)
      if(response?.error == null){
        if(response !== null && (response.statusCode !== 400 && response.statusCode !== 404 && response.error == null)  ){
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('username');
          localStorage.setItem('access_token', response?.access_token);
          localStorage.setItem('refresh_token', response?.refresh_token);
          localStorage.setItem('username', response?.username);
          let data = {
            isreadytobuy: true,
            isShowOtp: false,
            showModal: false
          }
          yield put(createUserSuccess(data))
        }else{
          let data = {
            isreadytobuy: false,
            isShowOtp: false,
            showModal: true
          }
          yield put(createUserSuccess(data))
        }
      }else{
        let data = {
          isreadytobuy: false,
          isShowOtp: false,
          showModal: true
        }
        yield put(createUserSuccess(data))
      }
    } catch (error) {
      let data = {
        isreadytobuy: false,
        isShowOtp: false,
        showModal: true
      }
      yield put(createUserSuccess(data))
    }
  }


function* authSaga() {
    yield takeEvery(CREATE_USER, createUserSaga)
    yield takeEvery(VERIFY_OTP_NUMBER, sendOtpUpdateSaga)
    yield takeEvery(GET_ACCOUNT_INFO, getAccountInfoSaga)
  }
  
  export default authSaga